"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Component = void 0;
var Preact = __importStar(require("preact"));
var Box_1 = __importDefault(require("@mui/material/Box"));
var Typography_1 = __importDefault(require("@mui/material/Typography"));
var Price = __importStar(require("./price"));
var Discount = __importStar(require("./A_DiscountPrice"));
var Button = __importStar(require("./A_Button"));
var Add_1 = __importDefault(require("@mui/icons-material/Add"));
var Component = function (p) {
    var _a, _b;
    return (Preact.h(Box_1.default, { sx: __assign({ backgroundColor: 'white', p: '12px', borderRadius: '8px', display: 'grid', gridGap: '12px' }, p.sx) },
        Preact.h("img", { style: { width: '100%', height: '100px', objectFit: 'contain' }, src: p.imageUrl }),
        Preact.h(Typography_1.default, { variant: "body1", sx: {
                // ---
                // the following is all to get ellipsis after the text
                // it should work on all but internet explorer
                textOverflow: 'ellipsis',
                overflow: 'hidden',
                display: '-webkit-box',
                '-webkit-box-orient': 'vertical',
                '-webkit-line-clamp': '2',
                // and just in case the above doesn't work, we can force the height to
                // be only 2 lines. This is font-size * line-height * lines,
                // so 0.75rem * 1.5 * 2
                height: '2.25rem',
                // ---
            } }, p.title),
        Preact.h(Box_1.default, { sx: { display: 'flex', alignItems: 'flex-end' } },
            Preact.h(Price.Component, { price: p.price }),
            p.lastPrice ? (Preact.h(Discount.Component, { discount: p.lastPrice, sx: { paddingLeft: '8px' } })) : null),
        p.leadTime ? (Preact.h(Typography_1.default, { variant: "body2", sx: { color: 'primary.dark' } }, p.leadTime)) : null,
        Preact.h(Button.Component, { variant: "contained", size: "small", disabled: (_a = p.disabled) !== null && _a !== void 0 ? _a : false, loading: (_b = p.loading) !== null && _b !== void 0 ? _b : false, sx: { backgroundColor: 'primary.main', width: 'max-content' }, startIcon: Preact.h(Add_1.default, null), onClick: p.onAddClick }, "Add")));
};
exports.Component = Component;
